<section>
    <div class="flex-start-center gap-x-2 text-base md:text-xl font-semibold" backButton>
        <span nz-icon nzType="antd:v2-back" nzTheme="outline" class="text-xl"></span>
        <div *ngIf="tokenInfo"><span>{{tokenInfo.symbol }}</span></div>
    </div>

    <div class="mt-10 flex-start-center gap-x-7 flex-wrap gap-y-4">
        <div class="relative">
            <nz-avatar
                [nzText]="tokenInfo?.name|slice:0:2"
                class="!bg-secondaryCard !text-black !text-[38px] min-w-16 md:w-[120px] min-h-16 md:h-[120px] !flex-center-center"
                [nzSrc]="tokenInfo?.logo"
            ></nz-avatar>

            <img
                *ngIf="tokenInfo?.chain_name"
                [src]="getChainImg(tokenInfo?.chain_name)"
                class="w-5 md:w-8 h-5 md:h-8 rounded-full absolute bottom-0 -right-3 border border-white"
                alt=""
            />
        </div>

        <div class="space-y-1.5 flex-1">
            <div>
                <span class="text-black font-semibold text-base md:text-xl">{{tokenInfo?.symbol || '--'}}</span>
                <span *ngIf="tokenInfo?.name" class="text-xs text-sub-text font-normal"> ({{tokenInfo?.name}})</span>
            </div>

            <div class="flex-start-center gap-x-2">
                <div class="text-sm hidden md:block">{{address}}</div>
                <div class="text-sm md:hidden">{{address | address}}</div>

                <app-copy [text]="address" [reminderMsg]="'Copied!'"></app-copy>
            </div>

            <div class="flex-start-center gap-x-2.5">
                <div class="text-sm flex-start-center gap-x-1">
                    <span class="text-sub-text">Age</span>
                    <span>{{age}}</span>
                </div>

                <div class="flex-start-center gap-2.5" *ngIf="tokenInfo?.social_medias?.length">
                    <ng-container *ngFor="let socialMedia of tokenInfo.social_medias">
                        <a *ngIf="socialMedia.name === 'twitter'" class="social-icon cursor-pointer" [href]="socialMedia.link" target="_blank">
                            <span nz-icon [nzType]="'antd:x'" class="text-sm"></span>
                        </a>

                        <a *ngIf="socialMedia.name === 'discord'" class="social-icon cursor-pointer" [href]="socialMedia.link" target="_blank">
                            <span nz-icon [nzType]="'antd:discord'" class="text-sm"></span>
                        </a>

                        <a *ngIf="socialMedia.name === 'telegram'" [href]="socialMedia.link" target="_blank" class="social-icon cursor-pointer">
                            <span nz-icon [nzType]="'antd:telegram'" class="text-sm"></span>
                        </a>

                        <a *ngIf="socialMedia.name === 'website'" [href]="socialMedia.link" target="_blank" class="social-icon cursor-pointer">
                            <span nz-icon [nzType]="'antd:website'" class="text-sm"></span>
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>

        <button nz-button nzType="primary" (click)="goToBuy()" class="md:!w-[145px] md:!h-16 max-md:flex-1">
            <img src="/assets/imgs/coin-v2.png" class="md:w-[28px] md:h-[28px] w-[20px] h-[20px]" alt="" />
            <span class="colorful-text font-semibold md:text-2xl ml-2">Buy</span>
        </button>
    </div>

    <!-- Token Info -->
    <div class="mt-4">
        <app-default-token-info *ngIf="chainName!== ChainEnum.SOL" [tokenInfo]="tokenInfo"></app-default-token-info>
        <app-v2-token-info *ngIf="chainName=== ChainEnum.SOL" [tokenInfo]="tokenInfo" [chain]="chainName" [tokenAddress]="address"></app-v2-token-info>
    </div>

    <div class="mt-4 md:mt-7">
        <div class="flex-between-center w-full mb-5">
            <div class="text-base font-semibold">Highlight Transactions</div>

            <div class="flex-start-center gap-x-2">
                <a class="max-md:hidden !pb-0" nz-button nzSize="small" [href]="viewAllHolderLink" target="_blank">
                    View All Holders
                    <span nz-icon nzType="link"></span>
                </a>

                <a class="max-md:hidden !pb-0" nz-button nzSize="small" [href]="viewAllTxLink" target="_blank">
                    View All TX
                    <span nz-icon nzType="link"></span>
                </a>
            </div>
        </div>

        <app-highlighted-txns [address]="address" [chainName]="chainName"></app-highlighted-txns>
    </div>

    <ng-template #tab1>
        <div class="flex-start-center gap-x-1">
            <div class="text-base">Highlight Holders</div>
            <span class="text-xs text-sub-text font-normal">(Top 10 owned <span class="text-black">{{top10Percentage | percent:'1.0-2'}}</span>)</span>
        </div>
    </ng-template>
</section>
